import { HistoryApiMessage, MediaItem, Message, StatusValues } from '../models/message';

function parseMediaUrls(mediaJson?: string): MediaItem[] {
  if (!mediaJson) return [];
  try {
    const urls: string[] = JSON.parse(mediaJson);
    return urls.map(url => ({
      url,
      filename: extractFilenameFromUrl(url),
      contentType: '', // Will be parsed from URL by media-preview component
      size: 0,
    }));
  } catch {
    return [];
  }
}

function extractFilenameFromUrl(url: string): string {
  try {
    const urlObj = new URL(url);
    // Try to get filename from response-content-disposition
    const disposition = urlObj.searchParams.get('response-content-disposition');
    if (disposition) {
      const match = disposition.match(/filename[^;=\n]*=\s*["']?([^"';\n]+)/);
      if (match?.[1]) return match[1];
    }
    // Fallback: extract from path
    const pathname = urlObj.pathname;
    return pathname.split('/').pop() || 'file';
  } catch {
    return 'file';
  }
}

export function mapHistoryMessage(apiMsg: HistoryApiMessage): Message {
  // Sent timestamp used for outbound messages, inbound messages we'll just use the received timestamp.
  // It's not far off and is always defined for inbound messages.
  const sentTimestamp = apiMsg.senttimestamp ? new Date(apiMsg.senttimestamp) : new Date(apiMsg.receivedtimestamp!);

  const receivedTimestamp = apiMsg.receivedtimestamp ? new Date(apiMsg.receivedtimestamp) : undefined;

  return {
    sid: apiMsg.sid,
    sender: { name: '', phoneNumber: apiMsg.sender },
    receiver: { name: '', phoneNumber: apiMsg.receiver },
    sentTimestamp,
    receivedTimestamp,
    content: apiMsg.content,
    status: apiMsg.status as StatusValues,
    media: parseMediaUrls(apiMsg.media),
  };
}
